export default __webpack_public_path__ + "static/media/sheehui.0e1c250d.png";